// extracted by mini-css-extract-plugin
export default {"marker":"marker_marker__ob-ok"};